/**
 * @typedef { import('./PayslipModel').PayslipModel } PayslipModel
 * @typedef { import('./PaymentGroupModel').PaymentGroupModel } PaymentGroupModel
 * @typedef { import('./PaymentModel').PaymentModel } PaymentModel
 */

export class PaymentLock {
    constructor() {
        this._isLocked = false;
        this._lockedGroup = null;
        this._lockedPayslip = null;
    }

    get isLocked() {
        return this._isLocked;
    }

    reset() {
        this._isLocked = false;
        this._lockedGroup = null;
        this._lockedPayslip = null;
    }

    /**
     * @param {PaymentGroupModel} pgm
     */
    lockGroup(pgm) {
        this._isLocked = true;
        this._lockedGroup = pgm;
        this._lockedPayslip = pgm.payslipModel;
    }

    /**
     * @param {PayslipModel} psm
     */
    lockPayslip(psm) {
        this._isLocked = true;
        this._lockedPayslip = psm;
    }

    /**
     * @param {PaymentGroupModel} pgm
     */
    isLockedForGroup(pgm) {
        return this._lockedGroup == pgm;
    }

    /**
     * @param {PayslipModel} psm
     */
    isLockedForPayslip(psm) {
        return this._lockedPayslip === psm;
    }
}
